import { heroCover, heroSideStories } from "@/mocks/homeData";

export default function CoverHero() {
  return (
    <section id="top" className="mx-auto max-w-[1400px] px-4 py-10 md:px-6 md:py-16">
      <div className="mb-6 flex items-end justify-between border-b-2 border-foreground-950 pb-3">
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          本期封面
          <span className="ml-2 align-middle font-label text-[11px] font-normal uppercase tracking-[0.28em] text-foreground-500">
            this week
          </span>
        </h2>
        <span className="hidden items-center gap-1.5 text-xs text-foreground-500 sm:flex">
          <i className="ri-time-line" />
          编辑部 · 每天 08:00 更新
        </span>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-8">
        <article className="group relative overflow-hidden rounded-lg border border-background-200 lg:col-span-7">
          <div className="relative h-[420px] w-full md:h-[560px]">
            <img
              src={heroCover.image}
              alt={`黑料社网封面故事 - ${heroCover.title}`}
              title={`${heroCover.title} - 黑料社网热门爆料`}
              className="h-full w-full object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent" />
          </div>

          <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 dark:text-foreground-950">
              <i className="ri-bookmark-fill" />
              {heroCover.tag}
            </span>
            <h3 className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
              {heroCover.title}
            </h3>
            <p className="mt-3 hidden max-w-2xl text-sm leading-relaxed text-background-100/90 sm:block">
              {heroCover.excerpt}
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-3 text-xs text-background-100/80">
              <span className="flex items-center gap-1.5">
                <i className="ri-user-3-line" />
                {heroCover.author}
              </span>
              <span className="h-3 w-px bg-background-50/30" />
              <span>{heroCover.date} 发布</span>
              <span className="h-3 w-px bg-background-50/30" />
              <span>{heroCover.readTime}</span>
            </div>
          </div>
        </article>

        <div className="flex flex-col lg:col-span-5">
          <div className="mb-3 flex items-center gap-2 text-sm font-semibold text-foreground-900">
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-flashlight-fill text-accent-500" />
            </span>
            本期看点
          </div>
          <div className="flex flex-col divide-y divide-background-200 border-y border-background-200">
            {heroSideStories.map((story, index) => (
              <a
                key={story.title}
                href="#stories"
                className="group flex items-center gap-4 py-4 transition-colors hover:bg-background-100/70"
              >
                <span className="w-6 shrink-0 font-heading text-lg font-bold text-foreground-300">
                  0{index + 1}
                </span>
                <div className="h-16 w-16 shrink-0 overflow-hidden rounded-md">
                  <img
                    src={story.image}
                    alt={`黑料社网热门爆料 - ${story.title}`}
                    title={`${story.title} - 黑料社网头条`}
                    className="h-full w-full object-top transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <span className="text-[11px] font-medium text-primary-600">#{story.tag}</span>
                  <h4 className="mt-1 line-clamp-2 font-heading text-sm font-semibold leading-snug text-foreground-900 md:text-[15px]">
                    {story.title}
                  </h4>
                  <span className="mt-1 flex items-center gap-1 text-[11px] text-foreground-500">
                    <i className="ri-fire-line" />
                    {story.heat} 热度
                  </span>
                </div>
              </a>
            ))}
          </div>

          <a
            href="#headlines"
            className="mt-4 flex items-center justify-center gap-2 rounded-md border border-background-300 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-foreground-950 hover:text-foreground-950"
          >
            浏览今日全部头条
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}